<template>
  <div>
    <i
      class="fas fa-times closing pointer exit-zen-mode"
      @click="exitCardsView"
    />
    <van-loading
      v-if="Object.keys(box.data).length == 0"
      size="24px"
      vertical
      class="loading"
    >
      {{ $t("loading") }}...
    </van-loading>
    <SwipeCardStack
      v-else-if="box.data && box.data.cards && box.data.cards.length > 0"
      :loading="this.box.loading"
    />
    <van-empty
      v-else
      image="error"
      :description="$t('no cards')"
      class="empty"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import SwipeCardStack from "@/components/SwipeCardStack";
import zenModeRequired from "@/mixins/zenModeRequired";

export default {
  name: "Box",
  mixins: [zenModeRequired],
  components: {
    SwipeCardStack
  },
  data() {
    return {
      initialCard: 0
    };
  },
  computed: {
    ...mapState("account", ["user"]),
    ...mapState("vokabel", ["box"]),
    name() {
      if (this.box && this.box.data && this.box.data.name) {
        return this.box.data.name;
      }
      return "";
    }
  },
  methods: {
    ...mapActions("vokabel", ["getBoxInformation", "getIssueTypes"]),
    ...mapActions("setting", ["navigateBack"]),
    ...mapMutations("setting", ["CLOSE_ZEN_MODE", "SET_BACK_ROUTE"]),
    exitCardsView() {
      this.navigateBack();
      this.CLOSE_ZEN_MODE();
    }
  },
  mounted() {
    this.getBoxInformation(this.$route.params.id);
    this.getIssueTypes();
    this.SET_BACK_ROUTE({
      name: "interim-box",
      params: {
        id: this.$route.params.id
      }
    });
  }
};
</script>

<style lang="scss">
.empty {
  height: 80vh;
  display: flex;
  align-self: center;
}
</style>
